// mf specific actions, here we will define actions which will only be used inside the feature specific sagas
// reducers are not needed


import { createAction } from '@reduxjs/toolkit';

const MODULE_PREFIX = '[ PaymentV2_MF ]';

const Actions = {
    fetchMfPaymentLandingDetails: `${MODULE_PREFIX} fetchMfPaymentLandingDetails`,
    cancelMfPayment: `${MODULE_PREFIX} cancelMfPayment`,
    initiateMfPayment: `${MODULE_PREFIX} initiateMfPayment`,
    reinitiateMfPaymentFlow: `${MODULE_PREFIX} reinitiateMfPaymentFlow`,
};

export const fetchMfPaymentLandingDetails = createAction(Actions.fetchMfPaymentLandingDetails);
export const cancelMfPayment = createAction(Actions.cancelMfPayment);
export const initiateMfPayment = createAction(Actions.initiateMfPayment);
export const reinitiateMfPaymentFlow = createAction(Actions.reinitiateMfPaymentFlow);
